module.exports = __webpack_public_path__ + "static/media/addorderbtn.419c6a41.svg";